module.exports = __webpack_public_path__ + "img/icon15.88607ea8.png";